export const siteInfo = {
  name: "瓜田黑料",
  fullName: "瓜田黑料 · 娱乐话题年度盘点站",
  slogan: "年度盘点 · TOP榜 · 名场面合集",
  intro:
    "瓜田黑料是一个专注娱乐话题复盘与合集整理的资讯门户。我们把一年里被反复讨论的话题、名场面与经典案例，整理成有结构、可检索、可回顾的目录，让你不必翻遍全网，也能快速补课、理性吃瓜。",
  email: "hello@guatianheiliao.com",
  cooperationEmail: "media@guatianheiliao.com",
  since: "2019",
  icp: "",
};

export const navLinks = [
  { name: "首页", path: "/" },
  { name: "年度盘点", path: "/rankings" },
  { name: "名场面合集", path: "/moments" },
  { name: "关于瓜田", path: "/about" },
  { name: "补课答疑", path: "/faq" },
];

export const categories = [
  {
    slug: "annual",
    name: "年度盘点",
    icon: "ri-calendar-check-line",
    desc: "按年梳理话题脉络，一条时间线看懂全年的起承转合。",
    count: 42,
  },
  {
    slug: "top",
    name: "TOP榜",
    icon: "ri-trophy-line",
    desc: "以热度、讨论量与回放量排序，看谁撑起了全年的讨论。",
    count: 36,
  },
  {
    slug: "moment",
    name: "名场面",
    icon: "ri-movie-2-line",
    desc: "被剪进二创、被反复回放的高光与翻车瞬间合集。",
    count: 58,
  },
  {
    slug: "profile",
    name: "人物志",
    icon: "ri-user-star-line",
    desc: "以人物为主线的成长与转折，还原一条被放大的曲线。",
    count: 24,
  },
  {
    slug: "case",
    name: "经典案例",
    icon: "ri-folder-shield-2-line",
    desc: "把同类争议拆开看：合约、版权、舞台改编到底在争什么。",
    count: 31,
  },
  {
    slug: "collection",
    name: "合集整理",
    icon: "ri-stack-line",
    desc: "按主题打包的补课清单，适合一次性把前因后果看明白。",
    count: 19,
  },
];

export const stats = [
  { label: "累计盘点话题", value: "1,286", suffix: "条" },
  { label: "名场面收录", value: "3,470", suffix: "个" },
  { label: "年度榜单期数", value: "96", suffix: "期" },
  { label: "月均补课读者", value: "48", suffix: "万" },
];

export const principles = [
  {
    icon: "ri-file-shield-2-line",
    title: "以公开信息为依据",
    desc: "所有盘点只基于节目播出内容与公开报道，不采信来源不明的截图与小作文。",
  },
  {
    icon: "ri-emotion-happy-line",
    title: "对事不对人",
    desc: "我们讨论的是事件本身与行业现象，不做人身攻击，也不替任何人下定论。",
  },
  {
    icon: "ri-links-line",
    title: "标注时间线",
    desc: "每个话题都尽量还原先后顺序，避免因为剪辑顺序产生的误读。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续更正",
    desc: "当事方有明确回应或后续进展时，我们会回到原文补充与更正。",
  },
];

export const testimonials = [
  {
    name: "追综不迷路",
    role: "老读者 · 3 年",
    content:
      "每次断网几天回来都跟不上话题，直接看年度盘点就能秒补课，时间线标得比我自己整理的还清楚。",
  },
  {
    name: "今天也在吃瓜",
    role: "合集党",
    content:
      "名场面那一栏是我的快乐源泉，尤其是二创合集，一下午能刷完一整年的高能瞬间。",
  },
  {
    name: "娱乐观察员老王",
    role: "行业从业者",
    content:
      "经典案例拆解做得挺克制，把合约、版权、改编这些争议拆开讲，比单纯骂战有营养多了。",
  },
  {
    name: "摸鱼研究所",
    role: "新读者",
    content: "TOP 榜的热度排序很对味，一眼就能看到今年讨论量最大的几个话题，补课效率拉满。",
  },
];

export const contactChannels = [
  { icon: "ri-mail-line", label: "内容与线索", value: "hello@guatianheiliao.com" },
  { icon: "ri-briefcase-line", label: "商务与投稿", value: "media@guatianheiliao.com" },
  { icon: "ri-time-line", label: "编辑部在线", value: "工作日 10:00 - 19:00" },
];